module.exports = __webpack_public_path__ + "img/ic_green_checkmark.23c063dd.svg";